const production: boolean = process.env.NODE_ENV === 'production';

const dataQa = (value: string): { 'data-qa': string } | null => {
  const attribute = production ? null : { 'data-qa': value };

  return attribute;
};

export default dataQa;
